let template = `<td><input type="checkbox" value="{{id}}" name="selected-device"></td>
<td class="item-id"><a class="details" href="/ide/devices/{{id}}">{{id}}</a>
{{#if name}}<div class="device-list-name">{{name}}</div>{{/if}}</td>
{{#if show.type}}<td class="type">{{device_type}}</td>{{/if}}
<td class="status small"></td>
{{#if show.rel_owner}}
<td class="owner"><span class="weak-text">Unassigned</span></td>
{{/if}}
{{#if show.rel_account}}
<td class="account"><span class="weak-text">Unassigned</span></td>
{{/if}}
{{#if show.rel_product}}
<td class="product"><span class="weak-text">Unassigned</span></td>
{{/if}}
{{#if show.rel_devicegroup}}
<td class="group"><span class="weak-text">Unassigned</span></td>
{{/if}}
{{#if show.last_enrolled}}
<td class="enrolled">
  {{#if last_enrolled_at}}
    {{#date_UTC}}{{last_enrolled_at}}{{/date_UTC}}
  {{else}}
   <span class="weak-text">Unenrolled</span>
  {{/if}}
</td>
{{/if}}
{{#if show.actions}}
<td class="actions">
    {{#if show.action_code}}
  <button title="Code" class="btn btn-link code action"
      data-toggle="tooltip"
      data-placement="auto bottom">Code</button>
    {{/if}}
  <button title="Restart" class="btn btn-link restart action"
    {{#unless show.action_restart}}
      disabled="true"
    {{/unless}}
      data-toggle="tooltip"
      data-placement="auto bottom">Restart</button>
  <button title="Settings" class="btn btn-link edit action"
    {{#unless show.action_edit}}
      disabled="true"
    {{/unless}}
      data-toggle="tooltip"
      data-placement="auto bottom">Settings</button>
    {{#if show.action_assign}}
  <button title="Assign" class="btn btn-link assign action"
      data-toggle="tooltip"
      data-placement="auto bottom">Assign</button>
    {{/if}}
    {{#if show.action_unassign}}
  <button title={{unassign_text}} class="btn btn-link unassign action"
      data-toggle="tooltip"
      data-placement="auto bottom">{{unassign_text}}</button>
    {{/if}}
    {{#if show.action_delete}}
  <button title="Delete" class="btn btn-link delete action"
      data-toggle="tooltip"
      data-placement="auto bottom">Delete</button>
    {{/if}}
</td>
{{/if}}`;

let status_template = `
    <span>Device:</span>&nbsp;<i class="fa fa-circle {{status}}"  data-toggle="tooltip" title="Device Status: {{status}}"></i>
    <br>
    <span>Agent:</span>&nbsp;<i class="fa fa-circle  {{#if agent_running}}online{{else}}offline{{/if}}"
     data-toggle="tooltip"
     title="Agent Status: {{#if agent_running}}online{{else}}offline{{/if}}"></i>
    {{#if agent_id}}
        <br><a href="{{agent_url}}" target="_blank" data-toggle="tooltip" title="Agent URL {{agent_url}}. Click to open in a new tab or window.">{{agent_id}}</a>
    {{/if}}`;

import _ from 'underscore';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import ConfirmationDialog from '@/views/dialogs/confirmation';
import DialogInterface from '@/interfaces/dialog';
import ResponseResultsView from '@/views/response_results_view';

var globalCh = Radio.channel('global');
var apiCh = Radio.channel('api');

/**
 * By default, these relationship regions will be shown for device
 * views. Override by providing your own 'show' object when
 * instantiating a device view. the templateHelpers function
 * below will turn off particular items based on certain parameters
 * of the device or one of its relationships (or lack thereof) or the
 * user's permissions on the device.
 *
 * Order of precedence, from high to low:
 *
 *     1. rules in templateHelpers
 *     2. options passed to the view
 *     3. defaults
 */

// Dont fetch things that have been fetched already
var memoize_fetch = _.memoize(function (model) {
    return model.fetch();
}, function (model) {
    return model.id;
});

const SHOW_DEFAULTS = Object.freeze({
    type: false,
    rel_owner: true,
    rel_account: true,
    rel_product: true,
    rel_devicegroup: true,
    last_enrolled: true,
    actions: true,
    action_unassign: true,
    action_delete: true,
    action_assign: true,
    action_edit: true,
    action_code: true,
    action_restart: true,
});
/**
 * Map region names to 'show' keys
 */
const REGION_KEYMAP = Object.freeze({
    owner: 'rel_owner',
    account: 'rel_account',
    group: 'rel_devicegroup',
    product: 'rel_product'
});
// A quick way to make a v5 view
function create_v5_object_view(v5_object, options) {
    var view = new Marionette.View(_.extend({}, options, {
        events: function() {
            var model = this.model;
            var action;
            if (!model) return;
            // if (model.type !== 'account') return;
            if (!this.getOption('link')) return;
            if (model.type === 'account') {
                action = function() {
                    globalCh.request('changeActiveAccount', model, function() {
                        globalCh.request('home');
                    });
                };
            } else if ( model.type.indexOf('devicegroup') > -1 ) {
                action = function(e) {
                    if ( e.which === 1 ) {
                        globalCh.request('show_devicegroup_dashboard', model);
                        return false;
                    }
                };
            }
            return {
                'click': action
            };
        },
        tagName: function() {
            if (this.getOption('link')) {
                return 'a';
            } else {
                return 'div';
            }
        },
        attributes: function() {
            if ( this.getOption('link') ) {
                return {
                    'href' : '/ide/devicegroup/' + this.model.id
                };
            }
        },
        className: function() {
            if (this.getOption('link')) {
                return 'btn btn-link';
            }
        },
        model: v5_object,
        modelEvents: { 'change': 'render' },
        template: Handlebars.compile('{{name}}'),
        onRender: function(){
            // Products weren't showing up, and were causing issues with code editor
            if (this.model) {
                if (Object.keys(this.model.attributes).length < 2) {
                    memoize_fetch(this.model);
                }
            }
        },
        templateContext : function(){
            if ( !v5_object ) {
                return { name: '' };
            } else if (v5_object.get('username') === undefined ){
                return { name: v5_object.get('name') };
            } else {
                return { name: v5_object.get('username') };
            }
        }
    }));
    return view;
}
/**
 * A view specifically for an owner of a devicegroup
 *
 * This is essentially a special devicegroup view, and that's
 * what you pass as the model. Then this view manages loading
 * the account information.
 */
function create_account_view(v5_object) {
    var view = new Marionette.View({
        model: v5_object,
        modelEvents: { 'change': 'render' },
        template: Handlebars.compile('<div class="inside-account">&lt;inside-unloaded&gt;</div>'),
        regions: {
            account: '.inside-account'
        },

    });
    view.get_account = function get_account() {
        var devicegroup = this.model;
        if (!devicegroup) return;
        var account = devicegroup.rel.get('owner');
        return account;
    };
    view.show_account = function show_account() {
        var account = this.get_account();
        if (!account) return;
        this.showChildView('account', create_v5_object_view(account, { link: false }));
    };
    view.onRender = function onRender() {
        var account = this.get_account();
        // If account looks baked enough for us, show the view
        if (account.get('username')) {
            this.show_account();
        } else {
            // Otherwise, fetch first then show the view
            account.fetch().then(_.bind(this.show_account, this));
        }
    };
    return view;
}

var response_dialog = ResponseResultsView.extend(DialogInterface).extend({
    initialize: function(){
        this.destroyOnClose();
    }
});

var view = Marionette.View.extend({
    ui: {
        item_id: '.item-id .details',
        checkbox: 'input[type="checkbox"]',
        restart: '.actions .restart',
        assign: '.actions .assign',
        edit: '.actions .edit',
        unassign: '.actions .unassign',
        delete: '.actions .delete',
        group: '.group',
        owner: '.owner',
        account: '.account',
        product: '.product',
        status: '.status',
        code: '.actions .code',
        download_code: '.download-code',
        tooltips: '[data-toggle="tooltip"]'
    },
    regions: {
        group: '@ui.group',
        owner: '@ui.owner',
        account: '@ui.account',
        product: '@ui.product',
        status: '@ui.status'
    },
    events: {
        'click @ui.item_id': 'show_device_details',
        'click @ui.restart': 'restart_device',
        'click @ui.assign': 'assign_device',
        'click @ui.edit': 'edit_device',
        'click @ui.unassign': 'unassign_device',
        'click @ui.delete': 'confirm_delete_device',
        'click @ui.checkbox': function() { this.trigger('child_selected'); },
        'click @ui.code': 'show_code_editor',
        'click @ui.download_code': 'download_code',
    },
    modelEvents: {
        'change': 'render'
    },
    template: Handlebars.compile(template),
    serializeData: function() {
        var attrs = this.model.toJSON();
        var group = this.model.rel.get('devicegroup');
        if (group) {
            if (
                [
                    'pre_production_devicegroup',
                    'production_devicegroup'
                ].includes(group.type)
                && !this.model.get('agent_id')
            ) {
                attrs.agent_id = 'Unenrolled';
            }
        } else {
            attrs.agent_id = 'Unassigned';
        }
        return attrs;
    },
    // TODO: See views/device_item_view.js. Duplicated code, extract. 
    show_settings_generator: function(){
        var active = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');

        var devicegroup = this.model.rel.get('devicegroup');

        var show = _.extend({}, SHOW_DEFAULTS, this.getOption('show'));
        var disabled_items = [];

        var is_device_owner = this.model.rel.get('owner') === active;
        // Falsify one value in the show object
        // This will override anything in the defaults or options
        function falsify(key) { show[key] = false; }

        // If assigned to development devicegroup, and is thus a Development Device
        if (devicegroup && devicegroup.type === 'development_devicegroup') {
            disabled_items = ['action_delete'];
            if (!active.permits(primary, 'restart_development_device')) {
                disabled_items.push('action_restart');
            }
            if (!active.permits(primary, 'update_development_device')) {
                disabled_items.push('action_assign');
            }
            if (!active.permits(primary, 'view_development_deployments')) {
                disabled_items.push('action_code');
            }
        // If assigned to pre_factoryfixture devicegroup, and is thus a Test Factory BlinkUp Fixture
        } else if (devicegroup && devicegroup.type === 'pre_factoryfixture_devicegroup') {
            disabled_items = ['action_delete'];
            if (!active.permits(primary, 'restart_pre_factory_device')) {
                disabled_items.push('action_restart');
            }
            if (!active.permits(primary, 'update_pre_factory_device')) {
                disabled_items.push('action_assign');
            }
            if (!active.permits(primary, 'delete_pre_factory_device')) {
                disabled_items.push('action_unassign');
            }
        } else if (devicegroup && devicegroup.type === 'factoryfixture_devicegroup') {
            disabled_items = [
                'action_code',
                'action_delete'
            ];
            if (!this.model.get('last_enrolled_at') || !active.permits(primary, 'restart_factory_device')) {
                disabled_items.push('action_restart');
            }
            if (!active.permits(primary, 'update_factory_device')) {
                disabled_items.push('action_assign');
            }
        } else if (devicegroup && devicegroup.type === 'pre_dut_devicegroup') {
            disabled_items = [
                'action_assign',
                'action_unassign',
                'action_restart'
            ];
            // If not assigned to any devicegroup
        } else if (devicegroup && devicegroup.type === 'dut_devicegroup') {
            disabled_items = [
                'action_code',
                'action_assign',
                'action_delete',
                'action_restart'
            ];

        } else if (devicegroup && devicegroup.type === 'pre_production_devicegroup') {

            disabled_items = [
                'action_unassign'
            ];
            if (!this.model.get('last_enrolled_at') || !active.permits(primary, 'restart_pre_production_device')) {

                disabled_items.push('action_restart');
            }
            if (!active.permits(primary, 'update_pre_production_device')) {
                disabled_items.push('action_assign');
                disabled_items.push('action_unassign');
            }
            // If not assigned to any devicegroup
            
        } else if (devicegroup && devicegroup.type === 'production_devicegroup') {

            disabled_items = [
                'action_code',
                'action_delete',
            ];
            if (!this.model.get('last_enrolled_at') || !active.permits(primary, 'restart_production_device')) {

                disabled_items.push('action_restart');
            }
            if (!active.permits(primary, 'update_production_device')) {
                disabled_items.push('action_assign');
                disabled_items.push('action_unassign');
            }
            // If not assigned to any devicegroup
        } else {
            disabled_items = [
                'action_code',
                'action_restart',
                'action_unassign'
            ];
        }

        // Turn off anything we've specified above
        disabled_items.forEach(falsify);
        // A device with no devicegroup cannot be unassigned
        show.action_unassign = show.action_unassign && devicegroup;
        // A user who is not the owner cannot delete a device
        show.action_delete = show.action_delete && is_device_owner;
        return show;
    },
    templateContext: function() {
        var devicegroup = this.model.rel.get('devicegroup');
        var unassign_text = 'Unassign';
        if (devicegroup && devicegroup.type === 'production_devicegroup') {
            unassign_text = 'Delete';
        }
        var show = this.show_settings_generator();
        return {
            show: show,
            status: this.model.get('device_online') ? 'online' : 'offline',
            agent_running: this.model.get('agent_running'),
            agent_url: this.model.get('agent_url'),
            agent_id: this.model.get('agent_id'),
            unassign_text: unassign_text,
        };
    },
    restart_device: function() {
        this.model.restart();
        globalCh.request('layout_alert', 'Device was successfully restarted', 'success', 5000);
        // TODO: Restart alert goes here
    },
    assign_device: function() {
        var groups = apiCh.request('development_devicegroup');
        // Devices assinged to production devicegroups can only be assigned
        // to other production devicegroups;
        // Devices assigned to other devicegroups, or not assigned to any
        // devicegroup cannot be assigned to production devicegroups.
        // var omitted_types;
        // if ( this.model.devicegroup
        //   && this.model.devicegroup.type === groups.TYPES_MAP.production
        // ) {
        //     omitted_types = _.chain(groups.TYPES_MAP)
        //         .omit('development', 'factory')
        //         .keys()
        //         .value();
        // } else {
        //     omitted_types = [groups.TYPES_MAP.production];
        // }
        // In the case of unassigned devices, a user
        // should be able to move a device to either
        // development or fixture device groups
        var omitted_types = [];
        var active = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');
     
        if (!this.model.rel.get('devicegroup')) {
            omitted_types.push(groups.TYPES_MAP.production);
            omitted_types.push(groups.TYPES_MAP.pre_production);
        } else if (this.model.rel.get('devicegroup')
            && this.model.rel.get('devicegroup').type !== groups.TYPES_MAP.production) {
                omitted_types.push(groups.TYPES_MAP.production);
        }

        if (this.model.rel.get('devicegroup')
            && this.model.rel.get('devicegroup').type.indexOf('factory') < 0 ) {
            omitted_types.push(groups.TYPES_MAP.factoryfixture);
        }

        if (this.model.rel.get('devicegroup')
            && this.model.rel.get('devicegroup').type !== groups.TYPES_MAP.pre_production) {
            omitted_types.push(groups.TYPES_MAP.pre_production);
        }

        if (this.model.rel.get('devicegroup')
            && this.model.rel.get('devicegroup').type === groups.TYPES_MAP.development) {
            omitted_types = [groups.TYPES_MAP.pre_production, groups.TYPES_MAP.production];
        }


        if (!active.permits(primary, 'update_development_device')) {
            omitted_types.push(groups.TYPES_MAP.development);
        }
        if (!active.permits(primary, 'update_factory_device')) {
            omitted_types.push(groups.TYPES_MAP.pre_factoryfixture);
        }
        globalCh.request('show_move_devices_dialog', {
            device_ids: [this.model.id],
            omitted_types: omitted_types,
            selected_devicegroup: this.model.rel.get('devicegroup'),
            selected_product: this.model.rel.get('product'),
        });
    },
    edit_device: function() {
        globalCh.request('show_device_settings_dialog', this.model);
    },
    unassign_device: function() {
        // Production devicegroups have to confirm 
        var group = this.model.rel.get('devicegroup');
        // Devices belonging to production devicegroups have their own 
        // special dialog which requires an unbless key
        if (group && group.type === 'production_devicegroup') {
            return globalCh.request(
                'show_delete_production_device_dialog',
                this.model
            );
        }
        // Everything else unassigns with no confirmation
        this.model.unassign(
            {
                success: _.bind(function(){
                    globalCh.request('layout_alert', ' Successfully unassigned ' + this.model.type + ' ' + this.model.id, 'success', 4000);
                }, this),
                error: _.bind(function(e){
                            globalCh.request('showDialog', new response_dialog({ resp : e }));
                        }, this)
            }
        );
    },
    confirm_delete_device: function() {
        var confirmation_dialog = new ConfirmationDialog({
            callback: this.delete_device.bind(this),
            message: {
                title: 'Delete Devices',
                target: this.model.get('name') || this.model.id,
                body: 'You are about to delete device ' + (this.model.get('name') || this.model.id) + '.<br>' +
                    'This device will remain offline until configured again using BlinkUp™',
                primary_action: 'Delete'
            }
        });

        globalCh.request('showDialog', confirmation_dialog);
    },
    delete_device: function() {
        this.model.destroy({ wait: true })
            .done(function() {
                globalCh.request(
                    'layout_alert',
                    'Deleted device ' + this.model.id,
                    'success',
                    5000
                );
            }.bind(this))
            .fail(function(response) {
                globalCh.request('showDialog', new response_dialog({ resp : response }));
            }.bind(this));
    },
    /*
        * v5_object_regions function & var the_regions
        *
        * In order to meet requirements for Device Detail view, which
        * extends this Device View, I needed to make the options of
        * having a Account or Owner be a link or not.
        *
        * v5_object_regions must be a function, so the app does not
        * attempt to load the data on init, which would fail
        *
        * see controllers/show_device for an example of extending this
        */
    v5_object_regions : function(){
        return [
            { name: 'owner', model: this.model.rel.get('owner'), link: false },
            { name: 'product', model: this.model.rel.get('product'), link: false },
        ];
    },
    /**
     * Should this view try to show the region identified by region_name,
     * given parameters and settings passed to the view?
     */
    should_show_region: function(region_name) {
        var show = _.extend({}, SHOW_DEFAULTS, this.getOption('show'));
        return show[ REGION_KEYMAP[region_name] ];
    },
    onRender: function() {
        var devicegroup = this.model.get('devicegroup');
        var the_regions = this.v5_object_regions();
        the_regions.forEach(function(region) {
            var options = {};
            if (region.model && region.model.type === 'account' && region.link === true) {
                options.link = true;
            }
            if (this.should_show_region(region.name)) {
                if ( this.assign_devices_view === true) options.link = false;
                this.showChildView(region.name, create_v5_object_view(region.model, options));
            }
        }, this);

        // Show the account view
        // This is called from inside show_devicegroup_and account
        var show_account = _.bind(function show_account() {
            if (!this.should_show_region('account')) return;

            var account = devicegroup.rel.get('owner');
            var region = this.getRegion('account');
            if (account) {
                if (region) region.show(create_account_view(devicegroup));
            }
        }, this);

        // Show the devicegroup and account regions
        var show_devicegroup_and_account = _.bind(function show_devicegroup_and_account() {
            var devicegroup_view;
            var group_region;
            if (!this.should_show_region('group')) return;
            var group_link = !this.assign_devices_view;
            if (devicegroup && devicegroup.type) {
                // render devicegroup and account views
                group_region = this.getRegion('group');
                if (group_region) {
                    devicegroup_view = this.showChildView(
                        'group',
                        create_v5_object_view(devicegroup, { link: group_link })
                    );
                }
                show_account();
                devicegroup_view.listenTo(devicegroup.rel, 'change:account', show_account);
            } else {
                // If there is no devicegroup owner, just show a null view.
                // No time to investigate right onw, but this fixes WEB-1308
                // where absence of this view caused the group 'Unassigned' text
                // to slide into the Account column
                if (!this.should_show_region('account')) return;
                var active = globalCh.request('active_account');
                if (this.model.rel.get('owner')) {
                    this.showChildView(
                        'account',
                        create_v5_object_view(this.model.rel.get('owner'))
                    );
                } else {
                    this.showChildView(
                        'account',
                        create_v5_object_view(active)
                    );
                }
            }
        }, this);
        show_devicegroup_and_account();
        this.listenTo(devicegroup, 'change', show_devicegroup_and_account);

        // Status Region
        if ( this.regions.status ) {
            let status_region = Marionette.View.extend({
                template: Handlebars.compile(status_template),
                templateContext: function() {
                    return {
                        status: this.model.get('device_online') ? 'online' : 'offline',
                        agent_running: this.model.get('agent_running'),
                        agent_url: this.model.get('agent_url'),
                        agent_id: this.model.get('agent_id')
                    };
                }
            });

            this.showChildView('status', new status_region({ model: this.model }));
        }

        this.apply_tooltips();
    },
    apply_tooltips: function() {
        // do not apply tooltips to management links
        this.ui.tooltips.tooltip();
    },
    show_code_editor: function() {
        var devicegroup = this.model.rel.get('devicegroup');
        var device = this.model;
        globalCh.request('showCodeEditor', devicegroup.draft, devicegroup, device);
    },
    show_device_details: function(e) {
        if ( e.which === 1) {
            globalCh.request('show_device', this.model);
            return false;
        }
    },
    download_code: function(){
        const deployment = this.model.rel.get('deployment');
        if (deployment && 
            deployment.can_download_code(
                this.model.rel.get('devicegroup'))){
            deployment.download();
        } else {
            return;
        }
    }

});
export default view;

